/**
 * @name index.js
 * @description Main entrypoint for vuex store.
 * @author Kelvin John Santos
 * @version 1.0
 * @since March 20, 2019
 */

import Vue from "vue";
import Vuex from "vuex";
import configModule from "./modules/config-module";
import publicSbaModule from "./modules/public-sba-module";
import companyUsersModule from "./modules/company-users-module";
import { applySiteSettings } from "../utilities/partner-util";
// import sleekAccessControlModule from "./modules/sleek-access-control-module";
import codingEngineModule from "./modules/coding-engine-module";
import { Constants } from "customer-sdk/constants";

const { SLEEK_APP_CACHE_KEY } = Constants.STORE_CONSTANTS;

Vue.use(Vuex);

// let appInternalConfig = JSON.parse(localStorage.getItem("appInternalConfig"));
// const debug = appInternalConfig.VUE_APP_SLEEK_ENV !== "production";
let debug = false;

const localStoragePlugin = (store) => {
  store.subscribe((mutation, data) => {
    window.localStorage.setItem(SLEEK_APP_CACHE_KEY, JSON.stringify(data));
    applySiteSettings();
  });
};

export default new Vuex.Store({
  modules: {
    platformConfig: {},
    configModule,
    companyUsersModule,
    codingEngineModule,
    publicSbaModule,
    // sleekAccessControlModule,
  },
  mutations: {
    updatePlatformConfig(state, data) {
      state.platformConfig = data;
    },
  },
  strict: debug,
  plugins: debug ? [createLogger(), localStoragePlugin] : [localStoragePlugin],
});
